import React from 'react';
import AnushaPage from './components/anusha/AnushaPage';

/* madlyours.com — the whole site IS our little world. No header, no footer,
   no routes; the vault renders at the root. */
export default function App() {
  return <AnushaPage />;
}
